"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SizesInnerToJSON = exports.SizesInnerFromJSONTyped = exports.SizesInnerFromJSON = exports.instanceOfSizesInner = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the SizesInner interface.
 */
function instanceOfSizesInner(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSizesInner = instanceOfSizesInner;
function SizesInnerFromJSON(json) {
    return SizesInnerFromJSONTyped(json, false);
}
exports.SizesInnerFromJSON = SizesInnerFromJSON;
function SizesInnerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'label': !(0, runtime_1.exists)(json, 'label') ? undefined : json['label'],
        'value': !(0, runtime_1.exists)(json, 'value') ? undefined : json['value'],
    };
}
exports.SizesInnerFromJSONTyped = SizesInnerFromJSONTyped;
function SizesInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'label': value.label,
        'value': value.value,
    };
}
exports.SizesInnerToJSON = SizesInnerToJSON;
